export default "__VITE_ASSET__c35ec6aa__"